const students = [
  {
    user_id: 1,
    fullname: "Charlie Brooks",
    email: "cb@email.com",
  },
  {
    user_id: 2,
    fullname: "Tim Smith",
    email: "ts@email.com",
  },
  {
    user_id: 3,
    fullname: "Becky Taylor",
    email: "bt@email.com",
  },
  {
    user_id: 4,
    fullname: "Brett Carson",
    email: "bc@email.com",
  },
  {
    user_id: 5,
    fullname: "Amy Fisher",
    email: "af@email.com",
  },
  {
    user_id: 6,
    fullname: "Dominique Brass",
    email: "db@email.com",
  },
  {
    user_id: 7,
    fullname: "Sarah Chalmer",
    email: "sc@email.com",
  },
  {
    user_id: 8,
    fullname: "Bill Bonnette",
    email: "bb@email.com",
  },
]

export default students